import { render, staticRenderFns } from "./Totalizador.vue?vue&type=template&id=5966700c&scoped=true"
import script from "./Totalizador.vue?vue&type=script&lang=js"
export * from "./Totalizador.vue?vue&type=script&lang=js"
import style0 from "./Totalizador.vue?vue&type=style&index=0&id=5966700c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5966700c",
  null
  
)

export default component.exports